import { Grid, type IconJVSProps } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import './Outil.css';

interface OutilProps {
	disabled?: boolean;
	icon: IconJVSProps;
	title: string;
}

const Outil = ({ disabled = false, icon, title }: OutilProps) => (
	<Grid className={disabled ? 'outil outilDisabled' : 'outil'}>
		<Grid.Row className="outilRow">
			<Grid.Column width={2}>
				<Icon size={28} {...icon} />
			</Grid.Column>
			<Grid.Column width={14}>{title}</Grid.Column>
		</Grid.Row>
	</Grid>
);

export default Outil;
